import { useEffect, useState } from "react";

const metricsMap = [
  { label: "Month-to-date", key: "mtd" },
  { label: "1 Month", key: "1m" },
  { label: "3 Month", key: "3m" },
  { label: "6 Month", key: "6m" },
  { label: "1 Year", key: "1y" },
  { label: "Annual Return", key: "annualised_return" },
  { label: "Annual Risk", key: "annualised_risk" },
  { label: "Sharp Ratio", key: "sharpe_ratio" },
];

const MFPerformanceMetrics = ({ navPerformance, benchmarkPerformance, onChangeLoading,showContent }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isNavValid = navPerformance && Object.keys(navPerformance).length > 0;
    const isBenchValid = benchmarkPerformance && Object.keys(benchmarkPerformance).length > 0;

    if (isNavValid && isBenchValid && loading) {
      setLoading(false);
      onChangeLoading?.(false);
    }
  }, [navPerformance, benchmarkPerformance, loading]);


  const format = (key, value) => {
    if (typeof value !== "number") return "--";
    return key === "sharpe_ratio" ? value.toFixed(2) : `${value.toFixed(2)}%`;
  };

  const metrics = metricsMap.map(({ label, key }) => ({
    label,
    value: format(key, navPerformance?.[key]),
    subValue: format(key, benchmarkPerformance?.[key]),
  }));

  return (
    <>
    {showContent &&(
      <div className="performance-metrics">
      <div className="performance-metrics-row">
        {metrics.map((metric, idx) => (
          <div key={idx} className={`metric-card ${idx % 2 === 0 ? "" : "right"}`}>
            <div className="metric-label">{metric.label}</div>
            <div className="metric-value">{metric.value}</div>
            <div className="metric-subvalue">{metric.subValue}</div>
          </div>
        ))}
      </div>
    </div>
    )}
    </>
  );
};

export default MFPerformanceMetrics